import React, { useState, useRef, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const productImages = [
  'https://www.christies.com/img/LotImages/2020/PAR/2020_PAR_20148_0012_000(cartier_diamonds_onyx_and_emerald_panthere_de_cartier_bracelet_two_exc070023).jpg?mode=max',
  'https://www.blingproud.com/cdn/shop/products/iced-out-diamond-prong-cuban-link-bracelet-in-white-gold-753677_1800x1800.jpg?v=1687169240',
  'https://i.pinimg.com/originals/97/83/1b/97831b9d17eb82d0e662c711f03e0947.jpg',
  'https://chairish-prod.freetls.fastly.net/image/product/sized/07b49b66-9449-460b-b37f-fcf279301adc/1990s-argentium-sterling-bracelet-0627?aspect=fit&width=640&height=640',
];

const generateDescription = (name) => {
  return `This elegant ${name} is meticulously crafted from premium silver by our skilled artisans. The sophisticated design adds a touch of class to any ensemble, perfect for both casual and formal occasions.`;
};

const SilverCollection = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [failedImages, setFailedImages] = useState({});
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSelectedProduct(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleImageError = (id) => {
    setFailedImages((prev) => ({ ...prev, [id]: true }));
  };

  const products = [
    {
      id: 1,
      name: 'Emerald-Eye Panther Chain Bracelet',
      image: productImages[0],
    },
    {
      id: 2,
      name: 'Urban Iced Cuban Link Bracelet',
      image: productImages[1],
    },
    {
      id: 3,
      name: 'Dual Panther Head Link Bracelet',
      image: productImages[2],
    },
    {
      id: 4,
      name: 'Executive Two Tone Link Bracelet',
      image: productImages[3],
    },
  ];

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  return (
    <section className="py-12 px-4 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4 sm:mb-0">
            Silver <span className="text-amber-600">Collection</span>
          </h2>
          <div className="flex gap-3">
            <button className="px-4 py-2 bg-white border border-stone-300 rounded-lg text-stone-700 text-sm font-medium hover:border-amber-500 hover:text-amber-600 transition-colors shadow-sm flex items-center gap-1">
              All Prices
              <span className="text-xs">▼</span>
            </button>
            <button className="px-4 py-2 bg-white border border-stone-300 rounded-lg text-stone-700 text-sm font-medium hover:border-amber-500 hover:text-amber-600 transition-colors shadow-sm flex items-center gap-1">
              All Products
              <span className="text-xs">▼</span>
            </button>
          </div>
        </div>
        <h3 className="text-xl font-semibold text-stone-700 mb-4">
          Silver Gents Bracelet
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {products.map((product) => {
            const imageFailed = failedImages[product.id];
            return (
              <div
                key={product.id}
                onClick={() => handleProductClick(product)}
                className="group bg-white rounded-lg shadow hover:shadow-md transition-all duration-300 overflow-hidden cursor-pointer transform hover:-translate-y-1"
              >
                <div className="aspect-square overflow-hidden bg-gray-100">
                  {!imageFailed ? (
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={() => handleImageError(product.id)}
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-full h-full bg-amber-200 flex items-center justify-center">
                      <span className="text-stone-800 text-sm text-center px-2">
                        {product.name}
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-2">
                  <h4 className="text-sm font-semibold text-stone-800 mb-1 line-clamp-2">
                    {product.name}
                  </h4>
                  <p className="text-xs text-amber-600 font-medium mt-1 group-hover:underline">
                    Click for details →
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        {selectedProduct && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
            <div
              ref={modalRef}
              className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            >
              <div className="relative">
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="absolute top-4 right-4 text-stone-500 hover:text-stone-800 transition-colors z-10"
                >
                  <FaTimes size={24} />
                </button>
                <div className="p-6">
                  <div className="flex flex-col md:flex-row gap-6">
                    <div className="md:w-1/2">
                      <img
                        src={selectedProduct.image}
                        alt={selectedProduct.name}
                        className="w-full h-auto object-cover rounded-xl shadow-md"
                      />
                    </div>
                    <div className="md:w-1/2">
                      <h2 className="text-2xl font-bold text-stone-800 mb-2">{selectedProduct.name}</h2>
                      <p className="text-stone-600 mb-4">{generateDescription(selectedProduct.name)}</p>
                      <div className="space-y-2">
                        <p className="text-sm text-stone-500">
                          <span className="font-medium">Material:</span> Silver
                        </p>
                        <p className="text-sm text-stone-500">
                          <span className="font-medium">Craftsmanship:</span> Handmade
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SilverCollection;